import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';

const MONTHS    = ['January','February','March','April','May','June','July','August','September','October','November','December'];
const WEEK_DAYS = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
const PLAT_META = {
  instagram:{ label:'Instagram', icon:'📸', color:'#e1306c' },
  facebook: { label:'Facebook',  icon:'👥', color:'#1877f2' },
  blog:     { label:'Blog',      icon:'📝', color:'#2e7d32' },
};

export default function ConsumerCalendar({ onNavigateCreate }) {
  const { conPosts, updateConPost } = useApp();
  const [calOffset, setCalOffset] = useState(0);
  const [dayPopup,  setDayPopup]  = useState(null);

  const today  = new Date();
  const anchor = new Date(today.getFullYear(), today.getMonth() + calOffset, 1);
  const y = anchor.getFullYear(), m = anchor.getMonth();
  const firstDow = (new Date(y, m, 1).getDay() + 6) % 7;
  const lastDate = new Date(y, m+1, 0).getDate();

  const days = [];
  for (let i = 0; i < firstDow; i++) days.push(null);
  for (let d = 1; d <= lastDate; d++) days.push(new Date(y, m, d));
  while (days.length % 7 !== 0) days.push(null);

  const byDate = {};
  conPosts.forEach(p => {
    const d = p.scheduled_date;
    if (d) { if (!byDate[d]) byDate[d]=[]; byDate[d].push(p); }
  });

  const unscheduled = conPosts.filter(p => !p.scheduled_date && p.status === 'draft');

  async function schedulePost(postId, dateStr) {
    await updateConPost(postId, { scheduled_date:dateStr, status:'scheduled' }).catch(console.error);
  }
  async function unschedulePost(postId) {
    await updateConPost(postId, { scheduled_date:null, status:'draft' }).catch(console.error);
  }

  const popupPosts       = dayPopup ? (byDate[dayPopup]||[]) : [];
  const popupUnscheduled = conPosts.filter(p => !p.scheduled_date && p.status==='draft');

  return (
    <div style={{ display:'flex', height:'100%', minHeight:0 }}>
      <div style={{ flex:1, overflowY:'auto', padding:'20px 24px' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:14 }}>
          <div>
            <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:700 }}>Consumer Calendar</div>
            <div style={{ fontSize:11, color:'#9ca3af', marginTop:2 }}>Facebook · Instagram · Blog</div>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <button className="btn btn-outline btn-sm" onClick={() => setCalOffset(o=>o-1)}>‹</button>
            <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:16, fontWeight:700 }}>{MONTHS[m]} {y}</div>
            <button className="btn btn-outline btn-sm" onClick={() => setCalOffset(o=>o+1)}>›</button>
            <button className="btn btn-sm" style={{ background:'var(--rose)', color:'#fff', border:'none', marginLeft:8 }} onClick={() => onNavigateCreate?.()}>+ Create Post</button>
          </div>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:3, marginBottom:3 }}>
          {WEEK_DAYS.map(d => <div key={d} style={{ textAlign:'center', fontSize:9.5, fontWeight:700, textTransform:'uppercase', letterSpacing:'.07em', color:'#9ca3af', padding:'4px 0' }}>{d}</div>)}
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:3 }}>
          {days.map((day, idx) => {
            if (!day) return <div key={`e-${idx}`} style={{ minHeight:72 }} />;
            const dateStr  = day.toISOString().split('T')[0];
            const dayPosts = byDate[dateStr]||[];
            return (
              <div key={dateStr}
                style={{ minHeight:72, borderRadius:8, border:'1.5px solid var(--border)', background:'var(--white)', padding:5, cursor:'pointer', transition:'border-color .15s' }}
                onClick={() => setDayPopup(dateStr)}
                onMouseOver={e => e.currentTarget.style.borderColor='var(--rose)'}
                onMouseOut={e => e.currentTarget.style.borderColor='var(--border)'}>
                <div style={{ fontSize:11, fontWeight:500, color:'var(--bark)', marginBottom:2 }}>{day.getDate()}</div>
                {dayPosts.slice(0,3).map(p => (
                  <div key={p.id} style={{ fontSize:8.5, fontWeight:600, padding:'1px 4px', borderRadius:3, marginBottom:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap',
                    background:(PLAT_META[p.platform]?.color||'#9ca3af')+'20', color:PLAT_META[p.platform]?.color||'#9ca3af' }}>
                    {PLAT_META[p.platform]?.icon||'📱'} {(p.title||'').slice(0,16)}
                  </div>
                ))}
                {dayPosts.length>3 && <div style={{ fontSize:8, color:'#9ca3af' }}>+{dayPosts.length-3}</div>}
              </div>
            );
          })}
        </div>

        {conPosts.filter(p=>p.status==='published').length>0 && (
          <div style={{ marginTop:24, paddingTop:16, borderTop:'2px solid var(--border)' }}>
            <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:16, fontWeight:700, marginBottom:10 }}>Published</div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))', gap:8 }}>
              {conPosts.filter(p=>p.status==='published').slice(0,6).map(p => (
                <div key={p.id} style={{ background:'var(--white)', borderRadius:'var(--r)', border:'1px solid var(--border)', padding:10, boxShadow:'var(--sh)' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:5 }}>
                    <span>{PLAT_META[p.platform]?.icon||'📱'}</span>
                    <span style={{ fontSize:11, fontWeight:700 }}>{PLAT_META[p.platform]?.label||p.platform}</span>
                    <span style={{ fontSize:10, color:'#9ca3af', marginLeft:'auto' }}>{p.published_at?.slice(0,10)||''}</span>
                  </div>
                  <div style={{ fontSize:11, color:'#4b5563', lineHeight:1.5, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>
                    {p.content||''}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Sidebar */}
      <div style={{ width:230, borderLeft:'1px solid var(--border)', overflowY:'auto', flexShrink:0 }}>
        <div style={{ padding:'12px 14px', borderBottom:'1px solid var(--border)', background:'var(--fog)', position:'sticky', top:0 }}>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:14, fontWeight:700 }}>Ready to Schedule</div>
        </div>
        {unscheduled.length === 0 ? (
          <div className="empty-state" style={{ padding:'24px 14px', fontSize:11 }}>
            <div style={{ fontSize:24, marginBottom:8 }}>📱</div>No posts ready.
          </div>
        ) : (
          unscheduled.map(p => (
            <div key={p.id} style={{ padding:'10px 13px', borderBottom:'1px solid var(--border)' }}>
              <div style={{ fontSize:11, fontWeight:700 }}>{p.title||p.type}</div>
              <div style={{ fontSize:10, color:'#9ca3af' }}>{PLAT_META[p.platform]?.label||p.platform}</div>
            </div>
          ))
        )}
      </div>

      {/* Day popup */}
      {dayPopup && (
        <>
          <div style={{ position:'fixed', inset:0, zIndex:8999 }} onClick={() => setDayPopup(null)} />
          <div style={{ position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)',
            background:'var(--white)', borderRadius:'var(--r)', border:'1.5px solid var(--border)',
            boxShadow:'var(--sh2)', width:400, maxHeight:'70vh', overflowY:'auto', zIndex:9000, padding:16 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:15, fontWeight:700 }}>{dayPopup}</div>
              <button onClick={() => setDayPopup(null)} style={{ width:22, height:22, borderRadius:4, border:'1px solid var(--border)', background:'var(--fog)', cursor:'pointer', fontSize:11 }}>✕</button>
            </div>
            {popupPosts.length>0 && (
              <>
                <div style={{ fontSize:10, fontWeight:700, textTransform:'uppercase', color:'#9ca3af', marginBottom:6 }}>Scheduled</div>
                {popupPosts.map(p => (
                  <div key={p.id} style={{ display:'flex', alignItems:'center', gap:8, padding:8, borderRadius:8, border:'1px solid var(--border)', marginBottom:5, background:'var(--fog)' }}>
                    <span style={{ fontSize:12 }}>{PLAT_META[p.platform]?.icon||'📱'}</span>
                    <div style={{ flex:1, fontSize:11.5, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.title||p.type}</div>
                    <button className="btn btn-ghost btn-xs" style={{ color:'var(--rose)' }} onClick={() => { unschedulePost(p.id); setDayPopup(null); }}>✕</button>
                  </div>
                ))}
              </>
            )}
            {popupUnscheduled.length>0 && (
              <>
                <div style={{ fontSize:10, fontWeight:700, textTransform:'uppercase', color:'var(--rose)', margin:'10px 0 6px' }}>Add from drafts</div>
                {popupUnscheduled.slice(0,6).map(p => (
                  <div key={p.id}
                    style={{ display:'flex', alignItems:'center', gap:8, padding:8, borderRadius:8, border:'1px solid var(--border)', marginBottom:5, cursor:'pointer' }}
                    onMouseOver={e => e.currentTarget.style.background='var(--fog)'}
                    onMouseOut={e => e.currentTarget.style.background=''}
                    onClick={() => { schedulePost(p.id, dayPopup); setDayPopup(null); }}>
                    <span style={{ fontSize:12 }}>{PLAT_META[p.platform]?.icon||'📱'}</span>
                    <div style={{ flex:1, fontSize:11.5, fontWeight:600 }}>{p.title||p.type}</div>
                    <span style={{ fontSize:10, color:'var(--rose)', fontWeight:600 }}>+ Add</span>
                  </div>
                ))}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
